/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import * as XLSX from "xlsx";
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function AddExchange() {
    const navigate = useNavigate();
    const location = useLocation();
    const existingData = location.state?.row;
    const [newRecord, setNewRecord] = useState({
        id: "",
        dealer_reg_no: "",
        date: "",
        exchange_reg_no: "",
        exchange_bike_model: "",
        exchange_bike_make: "",
        exchange_bike_color: "",
        exchange_bike_chase_no: "",
        exchange_bike_engine_no: "",
        exchange_noofowners: "",
        amount: "",
        description: "",
        name: "",
        address1: "",
        address2: "",
        city: "",
        phone1: "",
        phone2: "",
        isstocked: "",
        isexchange: "",
    });

    const [errors, setErrors] = useState({
        dealer_reg_no: "",
        date: "",
        exchange_reg_no: "",
        exchange_bike_model: "",
        exchange_bike_make: "",
        exchange_bike_color: "",
        exchange_bike_chase_no: "",
        exchange_bike_engine_no: "",
        exchange_noofowners: "",
        amount: "",
        name: "",
        address1: "",
        city: "",
        phone1: "",
    });
    const [registrations, setRegistrations] = useState([]);

    // Utility function
    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toISOString().split("T")[0]; // "2025-06-03"
    };


    useEffect(() => {
        //console.log("Exsisting:", existingData)
        if (existingData) {
            setNewRecord({
                id: existingData.id,
                dealer_reg_no: existingData.dealer_reg_no,
                date: formatDateForInput(existingData.date),
                exchange_reg_no: existingData.exchange_reg_no,
                exchange_bike_model: existingData.exchange_bike_model,
                exchange_bike_make: existingData.exchange_bike_make,
                exchange_bike_color: existingData.exchange_bike_color,
                exchange_bike_chase_no: existingData.exchange_bike_chase_no,
                exchange_bike_engine_no: existingData.exchange_bike_engine_no,
                exchange_noofowners: existingData.exchange_noofowners,
                amount: existingData.amount,
                description: existingData.description || "",
                name: existingData.name,
                address1: existingData.address1,
                address2: existingData.address2,
                city: existingData.city,
                phone1: existingData.phone1,
                phone2: existingData.phone2,
                isstocked: existingData.isstocked,
            });
        }
    }, [existingData]);

    useEffect(() => {
        const fetchRegistrationData = async () => {
            try {
                const endpoint = existingData
                    ? '/dealer/listforbilling'
                    : '/dealer/listforexchange';

                const response = await axiosInstance.get(endpoint);
                //console.log("Registration Response : ", response.data)
                let fetchedList = response.data?.data || [];

                // If editing, ensure the selected reg_no is included in the dropdown
                if (existingData) {
                    //setNewRecord({ ...existingData });

                    const alreadyIncluded = fetchedList.some(
                        item => item.reg_no === existingData.dealer_reg_no
                    );

                    // If not in the list, add it manually
                    if (!alreadyIncluded) {
                        fetchedList = [
                            ...fetchedList,
                            {
                                id: existingData.id,
                                reg_no: existingData.dealer_reg_no
                            }
                        ];
                    }
                }

                setRegistrations(fetchedList);
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setRegistrations([]);
            }
        };

        fetchRegistrationData();
    }, [existingData]);


    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.dealer_reg_no) {
            formErrors.dealer_reg_no = "Registration Number is required";
        }

        if (!newRecord.date) {
            formErrors.date = "Date is required";
        }

        if (!newRecord.exchange_reg_no) {
            formErrors.exchange_reg_no = "Exchange Registration Number is required";
        }

        if (!newRecord.exchange_bike_model) {
            formErrors.exchange_bike_model = "Bike Model is required";
        }

        if (!newRecord.exchange_bike_make) {
            formErrors.exchange_bike_make = "Make is required";
        }
        
        if (!newRecord.amount) {
            formErrors.amount = "Amount is required";
        }

        if (!newRecord.exchange_bike_color) {
            formErrors.exchange_bike_color = "Color is required";
        }

        if (!newRecord.exchange_bike_chase_no) {
            formErrors.exchange_bike_chase_no = "Chassis Number is required";
        }

        if (!newRecord.exchange_bike_engine_no) {
            formErrors.exchange_bike_engine_no = "Engine Number is required";
        }
        if (!newRecord.exchange_noofowners) {
            formErrors.exchange_noofowners = "No of Owners is Required";
        }

        if (!newRecord.name) {
            formErrors.name = "Name is required";
        }

        if (!newRecord.address1) {
            formErrors.address1 = "Address 1 is required";
        }

        if (!newRecord.city) {
            formErrors.city = "City is required";
        }

        if (!newRecord.phone1) {
            formErrors.phone1 = "Primary Phone is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };


    const handleRegSelectChange = (e) => {
        const selectedId = e.target.value;
        const selectedItem = registrations.find(item => item.id.toString() === selectedId);

        if (selectedItem) {
            setNewRecord({
                ...newRecord,
                id: selectedItem.id,
                reg_no: selectedItem.reg_no
            });
        } else {
            setNewRecord({
                ...newRecord,
                id: '',
                reg_no: ''
            });
        }
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (existingData) {
            if (validateForm()) {
                setErrors({});
                try {
                    // Ask for confirmation before proceeding with the edit
                    const result = await Swal.fire({
                        title: 'Are you sure?',
                        text: "Do you want to Update the changes?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, update it!'
                    });

                    if (result.isConfirmed) {
                        const modified_by = localStorage.getItem('user_id')

                        const updatedData = {
                            dealer_id: newRecord.dealer_id,
                            dealer_reg_no: newRecord.dealer_reg_no,
                            date: newRecord.date,
                            exchange_reg_no: newRecord.exchange_reg_no,
                            exchange_bike_model: newRecord.exchange_bike_model,
                            exchange_bike_make: newRecord.exchange_bike_make,
                            exchange_bike_color: newRecord.exchange_bike_color,
                            exchange_bike_chase_no: newRecord.exchange_bike_chase_no,
                            exchange_bike_engine_no: newRecord.exchange_bike_engine_no,
                            exchange_noofowners: newRecord.exchange_noofowners,
                            amount: newRecord.amount,
                            description: newRecord.description,
                            name: newRecord.name,
                            address1: newRecord.address1,
                            address2: newRecord.address2,
                            city: newRecord.city,
                            phone1: newRecord.phone1,
                            phone2: newRecord.phone2,
                            modified_by: modified_by,
                        };

                        try {
                            await axiosInstance.put(`/exchange/${existingData.id}`, updatedData, {
                                headers: {
                                    'Content-Type': 'application/json',
                                }

                            });

                            Swal.fire('Updated!', 'The Exchange record has been updated.', 'success');
                            navigate('/exchange');
                        } catch (error) {
                            console.error('Error updating data:', error);
                            Swal.fire('Error!', 'There was an issue in updating the exchange record.', 'error');
                        }
                    }
                } catch (error) {
                    setErrors((prev) => ({ ...prev, form: error.message }));
                }
            }
        } else {
            const created_by = localStorage.getItem('user_id')
            if (validateForm()) {
                // Proceed with form submission (API call or other actions)
                console.log("Form submitted", newRecord);
                const newRecordData = {
                    dealer_id: newRecord.id,
                    dealer_reg_no: newRecord.dealer_reg_no,
                    date: newRecord.date,
                    exchange_reg_no: newRecord.exchange_reg_no,
                    exchange_bike_model: newRecord.exchange_bike_model,
                    exchange_bike_make: newRecord.exchange_bike_make,
                    exchange_bike_color: newRecord.exchange_bike_color,
                    exchange_bike_chase_no: newRecord.exchange_bike_chase_no,
                    exchange_bike_engine_no: newRecord.exchange_bike_engine_no,
                    exchange_noofowners: newRecord.exchange_noofowners,
                    amount: newRecord.amount,
                    description: newRecord.description,
                    name: newRecord.name,
                    address1: newRecord.address1,
                    address2: newRecord.address2,
                    city: newRecord.city,
                    phone1: newRecord.phone1,
                    phone2: newRecord.phone2,
                    created_by: created_by,
                };
                console.log("Form submitted", newRecordData);
                try {
                    const response = await axiosInstance.post('/exchange/add', newRecordData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }

                    });

                    // Step 2: Check if POST was successful
                    if (response.status === 201) {
                        const dealerId = newRecordData.dealer_id;

                        if (dealerId) {
                            // Step 3: Update dealer finance flag
                            const updateResponse = await axiosInstance.put(`/dealer/isexchange/${dealerId}`);

                            console.log("Dealer updated:", updateResponse.data.message);
                        } else {
                            console.warn("Dealer ID not found in record data.");
                        }
                    }


                    setNewRecord({
                        id: "",
                        dealer_reg_no: "",
                        date: "",
                        exchange_reg_no: "",
                        exchange_bike_model: "",
                        exchange_bike_make: "",
                        exchange_bike_color: "",
                        exchange_bike_chase_no: "",
                        exchange_bike_engine_no: "",
                        exchange_noofowners: "",
                        amount: "",
                        description: "",
                        name: "",
                        address1: "",
                        address2: "",
                        city: "",
                        phone1: "",
                        phone2: "",
                        isstocked: "",
                    });

                    await Swal.fire('Created!', 'The Exchange record has been Created.', 'success');
                    navigate('/exchange');
                } catch (error) {
                    console.error('Error creating new exchange record:', error);
                    const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
                    Swal.fire('Error!', `There was an issue creating the exchange record: ${errorMessage}`, 'error');
                }
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "dealer_reg_no") {
            console.log("Selected reg_no:", value);
            console.log("Registrations list:", registrations);
            // Find selected vehicle from full registrations list
            const selected = registrations.find(item => item.reg_no === value);
            //alert(`Selected: ${JSON.stringify(selected)}`);
            //console.log("Matched Data:", selected)

            setNewRecord(prev => ({
                ...prev,
                id: selected?.id || "",
                dealer_reg_no: value,
            }));
        } else {
            const updatedRecord = {
                ...newRecord,
                [name]: value
            };


            setNewRecord(updatedRecord);
        }
    };
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{existingData ? "Edit Exchange" : "Add Exchange"}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/exchange">Exchange</a></li>
                                <li className="breadcrumb-item active">
                                    {existingData ? "Edit Exchange" : "Add Exchange"}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2 mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Registration No</label>
                                            <select
                                                id="dealer_reg_no"
                                                name="dealer_reg_no"
                                                className="form-control select2"
                                                value={String(newRecord.dealer_reg_no || '')}
                                                onChange={handleInputChange}
                                                disabled={!!existingData} // disable when editing
                                            >
                                                <option value="">Select a Registration No</option>
                                                {registrations.map(item => (
                                                    <option key={item.id} value={String(item.reg_no)}>
                                                        {item.reg_no}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.dealer_reg_no && <small className="text-danger">{errors.dealer_reg_no}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Date</label>
                                            <div className="input-group" id="date" data-target-input="nearest">
                                                <input
                                                    id="date"
                                                    type="date"
                                                    value={newRecord.date || ''}
                                                    onChange={(e) => setNewRecord(prev => ({ ...prev, date: e.target.value }))}
                                                    className="form-control"
                                                    data-target="#date"
                                                />
                                            </div>
                                            {errors.date && <small className="text-danger">{errors.date}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Exchange Registration No</label>
                                            <input type="text" name="exchange_reg_no" value={newRecord.exchange_reg_no} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_reg_no && <small className="text-danger">{errors.exchange_reg_no}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Bike Model</label>
                                            <input type="text" name="exchange_bike_model" value={newRecord.exchange_bike_model} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_bike_model && <small className="text-danger">{errors.exchange_bike_model}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Bike Make</label>
                                            <input type="text" name="exchange_bike_make" value={newRecord.exchange_bike_make} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_bike_make && <small className="text-danger">{errors.exchange_bike_make}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Bike Color</label>
                                            <input type="text" name="exchange_bike_color" value={newRecord.exchange_bike_color} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_bike_color && <small className="text-danger">{errors.exchange_bike_color}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Chassis Number</label>
                                            <input type="text" name="exchange_bike_chase_no" value={newRecord.exchange_bike_chase_no} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_bike_chase_no && <small className="text-danger">{errors.exchange_bike_chase_no}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Engine Number</label>
                                            <input type="text" name="exchange_bike_engine_no" value={newRecord.exchange_bike_engine_no} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_bike_engine_no && <small className="text-danger">{errors.exchange_bike_engine_no}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>No Of Owners</label>
                                            <input type="text" name="exchange_noofowners" value={newRecord.exchange_noofowners} onChange={handleInputChange} className="form-control" />
                                            {errors.exchange_noofowners && <small className="text-danger">{errors.exchange_noofowners}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Exchange Amount</label>
                                            <input type="text" name="amount" value={newRecord.amount} onChange={handleInputChange} className="form-control" />
                                            {errors.amount && <small className="text-danger">{errors.amount}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input type="text" name="name" value={newRecord.name} onChange={handleInputChange} className="form-control" />
                                            {errors.name && <small className="text-danger">{errors.name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Address 1</label>
                                            <input type="text" name="address1" value={newRecord.address1} onChange={handleInputChange} className="form-control" />
                                            {errors.address1 && <small className="text-danger">{errors.address1}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Address 2</label>
                                            <input type="text" name="address2" value={newRecord.address2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>City</label>
                                            <input type="text" name="city" value={newRecord.city} onChange={handleInputChange} className="form-control" />
                                            {errors.city && <small className="text-danger">{errors.city}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Primary Phone Number</label>
                                            <input type="text" name="phone1" value={newRecord.phone1} onChange={handleInputChange} className="form-control" />
                                            {errors.phone1 && <small className="text-danger">{errors.phone1}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Secondary Phone Number</label>
                                            <input type="text" name="phone2" value={newRecord.phone2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                name="description"
                                                value={newRecord.description}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                rows="3"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    <button type="submit" className="btn btn-primary">
                                        {existingData ? "Update Exchange" : "Save Exchange"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddExchange